import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class BudgetService {
  env = environment;
  constructor(private readonly http: HttpClient) { }

  saveUserBudget(data: any) {
    return this.http.post(this.env.webApiUrl + 'api/UserBudget/SaveUserBudget', data);
  }
  getUserBudgetInfo(totalCurrBal:string,creditId:string) {
    return this.http.post(this.env.webApiUrl + 'api/UserBudget/GetUserBudgetInfo', {totalCurrentBalance:totalCurrBal,creditHistoryId:creditId});
  }
  getUserYodleeMappingInfo()
  {
    return this.http.post(this.env.webApiUrl + 'api/UserBudget/GetUserYodleeTransactionMappingData', null);
  }
}
